import React, { memo } from 'react'

import { string } from 'prop-types'

import playIcon from 'images/play_icon.svg'

function ThumbVideoSlide({ src }) {
  return (
    <>
      <img
        alt="play icon"
        src={playIcon}
        width="26"
        height="26"
        loading="lazy"
        decoding="async"
        className="gallery-area-thumbs-carousel__media-icon"
      />
      <img
        className="gallery-area-thumbs-carousel__video-thumbnail"
        alt="thumbnail"
        src={src}
        width="90"
        height="90"
        loading="lazy"
        decoding="async"
      />
    </>
  )
}

ThumbVideoSlide.propTypes = {
  src: string.isRequired,
}

export default memo(ThumbVideoSlide)
